<script lang="ts" setup>
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faChevronRight as arrowIcon } from '@fortawesome/pro-regular-svg-icons'

/**
 * A list-style button for GSheet dialogs.
 * Used for action lists like delivery method selection.
 */
defineProps<{
  icon?: IconDefinition
  label: string
  description?: string
  disabled?: boolean
}>()

defineEmits<{
  click: [event: MouseEvent]
}>()
</script>

<template>
  <button
    type="button"
    :disabled="disabled"
    class="g-sheet-list-button flex items-center gap-4 p-3 w-full text-left transition-all rounded-2"
    @click="$emit('click', $event)"
  >
    <GIcon
      v-if="icon"
      :icon="icon"
      class="g-sheet-list-button-icon text-v2-secondary flex-shrink-0"
    />
    <div class="flex flex-col gap-0 flex-1">
      <span class="g-sheet-list-button-label text-base text-navy font-semibold">
        {{ label }}
      </span>
      <span v-if="description" class="text-sm text-secondary pre-line">
        {{ description }}
      </span>
    </div>
    <V2Icon
      :icon="arrowIcon"
      class="g-sheet-list-button-arrow text-grey-500 flex-shrink-0"
    />
  </button>
</template>

<style scoped>
.g-sheet-list-button {
  background-color: var(--list-button-bg-color);
  border: 2px solid var(--color-border-primary);
  border-radius: 8px;

  &:hover {
    background-color: var(--list-button-hover-bg-color);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .g-sheet-list-button-icon {
    height: 20px;
    width: 20px;
  }

  .pre-line {
    white-space: pre-line;
  }
}
</style>
